var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkMarkerSel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 60,
    viewBox: "0 0 45 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7747_128624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 59V43",
    stroke: "#61686B",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 3.5,
    width: 39.0012,
    height: 39,
    rx: 19.5,
    fill: "#A31610"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 3.5,
    width: 39.0012,
    height: 39,
    rx: 19.5,
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0008 17H25.0007V16C25.0007 15.2044 24.6846 14.4413 24.122 13.8787C23.5593 13.3161 22.7962 13 22.0005 13H20.0004C19.2048 13 18.4417 13.3161 17.879 13.8787C17.3164 14.4413 17.0003 15.2044 17.0003 16V17H14.0001C13.2045 17 12.4414 17.3161 11.8787 17.8787C11.3161 18.4413 11 19.2044 11 20V29C11 29.7956 11.3161 30.5587 11.8787 31.1213C12.4414 31.6839 13.2045 32 14.0001 32H28.0008C28.7965 32 29.5596 31.6839 30.1223 31.1213C30.6849 30.5587 31.001 29.7956 31.001 29V20C31.001 19.2044 30.6849 18.4413 30.1223 17.8787C29.5596 17.3161 28.7965 17 28.0008 17ZM19.0004 16C19.0004 15.7348 19.1058 15.4804 19.2933 15.2929C19.4808 15.1054 19.7352 15 20.0004 15H22.0005C22.2658 15 22.5201 15.1054 22.7077 15.2929C22.8952 15.4804 23.0006 15.7348 23.0006 16V17H19.0004V16ZM29.0009 29C29.0009 29.2652 28.8955 29.5196 28.708 29.7071C28.5204 29.8946 28.2661 30 28.0008 30H14.0001C13.7349 30 13.4806 29.8946 13.293 29.7071C13.1055 29.5196 13.0001 29.2652 13.0001 29V23.5C15.5465 24.5101 18.261 25.0293 21.0005 25.03C23.7398 25.0283 26.4542 24.5092 29.0009 23.5V29ZM29.0009 21.31C26.4792 22.4178 23.7548 22.9898 21.0005 22.9898C18.2461 22.9898 15.5218 22.4178 13.0001 21.31V20C13.0001 19.7348 13.1055 19.4804 13.293 19.2929C13.4806 19.1054 13.7349 19 14.0001 19H28.0008C28.2661 19 28.5204 19.1054 28.708 19.2929C28.8955 19.4804 29.0009 19.7348 29.0009 20V21.31Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7747_128624",
    x: 0,
    y: -1,
    width: 47,
    height: 61,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.121569 0 0 0 0 0.12549 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7747_128624"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7747_128624",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkMarkerSel);
export default __webpack_public_path__ + "static/media/workMarkerSel.1439957317afaaa190946a19983e9207.svg";
export { ForwardRef as ReactComponent };